import { z } from 'zod'

// Citation into a question answered on a similar past request surfaced by the `similar_requests` slice.
export const SimilarRequestCitationAgentInputSchema = z.object({
  type: z.literal('similar_request'),
  handle: z
    .string()
    .describe('Handle of the similar past request, copied exactly from the similar-requests list (e.g. "similar_request:1")'),
  questionName: z
    .string()
    .trim()
    .min(1)
    .describe('The question name shown next to the cited answer in the similar-request tool output'),
  anchor: z.string().trim().min(1).describe("Verbatim phrase copied from that answer's text"),
})

export const SimilarRequestCitationResolvedSchema = z.object({
  sourceType: z.literal('similar_request'),
  sourceLabel: z.string(),
  requestId: z.string(),
  requestFormId: z.string(),
  questionName: z.string(),
  questionTitle: z.string(),
  formTitle: z.string(),
  quote: z.string(),
  anchor: z.string(),
})
export type SimilarRequestCitationResolved = z.infer<typeof SimilarRequestCitationResolvedSchema>
